module.exports = __webpack_public_path__ + "img/30_1.d3e6b0d1.png";